/**
 * CMCD Version 1
 *
 * @public
 */
export const CMCD_V1 = 1 as const
